/* Portal configurations - global scope */

/* Define a product types for the portal.
 * id: product type's id
 * name: product type's name
 * available:
 */
const helper = {};

const accent_color = 'version1'; // color schema of the portal

const portal_name = 'Fitlandclub';

const activate_website = 1; // 1(all), 2(only portal), 3(only landing)

const landing_name = "Fitlandclub"; // FirstPortal, EbookPortal

const product_type = 4;

const portal_url = "fitlandclub.com";

const country_landing_url = [{
    'EE': 'https://premium.fitlandclub.com/Cf24aZ/',
    'LV': 'https://premium.fitlandclub.com/lVFc01/',
    'LT': 'https://premium.fitlandclub.com/mlT8Kd/mo/',
    'SK': 'https://premium.fitlandclub.com/FcO911/mo/',
	  'RO': 'https://premium.fitlandclub.com/vi1dRo/',
	  'FI': 'https://premium.fitlandclub.com/Cf2918/',
    'DK': 'https://premium.fitlandclub.com/Cf2ddP/',
    'SE': 'https://premium.fitlandclub.com/Tr2ddP/',
    'PL': 'https://premium.fitlandclub.com/CAz912/',
    'CH': 'https://premium.fitlandclub.com/cHFc01/',
    'RS': 'https://premium.fitlandclub.com/klFC01/',
    'CZ': 'https://premium.fitlandclub.com/fcCz0A/',
    'LU': 'https://premium.fitlandclub.com/CpA912/',
    'BG': 'https://premium.fitlandclub.com/OaoP12/',
    'MK': 'https://premium.fitlandclub.com/PAmQ23/',
    'BA': 'https://premium.fitlandclub.com/AaAb81/',
    'SI': 'https://premium.fitlandclub.com/sIDf01/',
    'AE': 'https://premium.fitlandclub.com/GlO6H3/',
    'RE': 'https://premium.fitlandclub.com/NvOnhj/click/',
    'CB': 'https://premium.fitlandclub.com/NvOnh8/click/',
    'PT': 'https://premium.runsio.com/pTFc00/'
}];

const country_default_language = {
    'UK': 'EN',
    'LU': 'EN',
    'CH': 'CH',
    'AE': 'EN',
    'LT': 'LT',
    'DE': 'DE'
};

const product_menu_items = [
{
    'id': 1,
    'name': 'Home',
    'available': 1,
    'type': 4,
	'banner': 1,
    'isActive': true,
    'countryExclusion': ''
},
{
    'id': 2,
    'name': 'Ebooks',
    'available': 1,
    'type': 3,
	'banner': 0,
    'isActive': false,
    'countryExclusion': ''
},
{
    'id': 3,
    'name': 'Apps',
    'available': 1,
    'type': 2,
	'banner': 0,
    'isActive': false,
    'countryExclusion': 'CA'
},
{
    'id': 4,
    'name': 'Videos',
    'available': 1,
    'type': 5,
	'banner': 0,
    'isActive': false,
    'countryExclusion': 'CA'
}];

const language_phones_format = {
    UK: '+44xxxxxxxxx',
	FI: '04xxxxxxxx',
	EE: '5xxxxxxx',
    LV: '2xxxxxxx',
    LT: '6xxxxxxx',
	RO: '07xxxxxxxx',
	SK: '09xxxxxxxx',
    DK: '47xxxxxxxxx',
    SE: '07xxxxxxxx',
    PL: 'xxxxxxxxx',
    CH: '07xxxxxxxx',
    RS: '06xxxxxxxx',
    CZ: '7xxxxxxxx',
    LU: '352xxxxxxxxx',
    BG: '359xxxxxxxx',
    MK: '389xxxxxxxx',
    SI: '0xxxxxxxx',
    BA: '06xxxxxxx',
    AE: '05xxxxxxxx',
    PT: '09xxxxxxx'
};

/*
 * Rating and Favourite feature enabled (1, 0)
 */
const use_rating = 1;
const use_favourite = 1;

// API Base URL
//prod
const API_BASE_URL = 'https://api.hubdelivery.io';
//local
// const API_BASE_URL = 'http://localhost:5001';

// apis
helper.api_PhoneNumber = "https://api.hubdelivery.io/landing/providePhoneNumberV2";
helper.api_ValidatePin = "https://api.hubdelivery.io/landing/validatePinCodeV2";
helper.api_SendAccessCodeByEmail = "https://api.hubdelivery.io/landing/sendAccessCodeByEmail";

helper.api_Search = 'https://api.hubdelivery.io/store/searchProducts';

// tracking api url
helper.ratingsAPI = "https://api.hubdelivery.io/store/addProductRating";
helper.favouriteAPI = "https://api.hubdelivery.io/store/addToFavourite";
helper.favouriteRemoveAPI = "https://api.hubdelivery.io/store/removeFromFavourite";

// Export API_BASE_URL for use in other components
helper.API_BASE_URL = API_BASE_URL;

// tracking default and generated values
helper.affiliate_landing = "AFFED8bcEzc";
helper.source_landing = "995PROVSUB996";
helper.landing_page_id = 'LPCPDT5FHRR';

// apis
helper.landingUrl = country_landing_url;
helper.languagePhoneFormat = language_phones_format;
helper.countryDefaultLanguage = country_default_language;
helper.menu = product_menu_items;
helper.portal_name = portal_name;
helper.portal_type = product_type;
helper.landing_name = landing_name;
helper.portal_url = portal_url;
helper.accent_color = accent_color;
helper.actice_website = activate_website;
helper.hasStars = use_rating;
helper.hasFavourite = use_favourite;

export const helpers = helper;
